"use client";

import { Empty } from "@/components/custom/empty";
import { Button } from "@/components/ui/button";

export default function GlobalError({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    // global-error must include html and body tags
    <html>
      <body className="h-screen">
        <Empty
          title="Something went wrong!"
          button={<Button onClick={() => reset()}>Try again!</Button>}
          className="h-full flex-col"
        />
      </body>
    </html>
  );
}
